<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Configuraciones iniciales y ayuda del sistema 
      </h2>
      <MainHelpMe />
    </div>
  </template>
  
  <script>
  import MainHelpMe from "@/components/HelpMe/MainHelpMe.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "HelpMe",
    components: {
        MainHelpMe,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  